import styled from 'styled-components';

import { NavLink } from 'reactstrap';

const StyledNavLink = styled(NavLink)`
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  font-size: 16px;
  cursor: pointer;
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
  color: ${({ active }) => (active ? '#0095FF' : '#767676')} !important;
  border-bottom: 2px solid ${({ active }) => (active ? '#0095FF' : '#DFE3EC')} !important;
  margin: 0;
  padding: 8px 0;
`;

export default StyledNavLink;
